import React from 'react';
import { Pressable, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { CLIENT_LEAD_STATUS_NAMES } from '../../../common/constants';
import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

// Existing leads whose name matches the one being typed, so a duplicate can be opened instead.
const LeadMatchList = ({ matches }) => {
	const styles = useThemedStyles(createStyles);
	const navigation = useNavigation();

	return (
		<View style={styles.matches}>
			<Text style={styles.matchesHeading}>Already in Sentry?</Text>
			{
				matches.map(lead => (
					<Pressable
						key={lead.id}
						style={({ pressed }) => [styles.match, pressed && styles.pressed]}
						onPress={() => navigation.push('LeadDetailView', { id: lead.id })}
						accessibilityRole="button"
					>
						<Text style={styles.matchName}>{lead.name || 'Unnamed lead'}</Text>
						<Text style={styles.matchMeta}>
							{[[lead.suburb, lead.state].filter(Boolean).join(', ') || 'No suburb', CLIENT_LEAD_STATUS_NAMES[lead.status]].filter(Boolean).join(' · ')}
						</Text>
					</Pressable>
				))
			}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space, radius, touch } }) => ({
	matches: {
		backgroundColor: colors.raised,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		borderRadius: radius.card,
		paddingHorizontal: space.md,
		paddingVertical: space.sm,
		marginTop: space.xs,
	},
	matchesHeading: {
		...type.secondarySemibold,
		color: colors.text,
		marginBottom: space.xs,
	},
	match: {
		minHeight: touch.min,
		justifyContent: 'center',
		paddingVertical: space.xs,
	},
	pressed: {
		opacity: 0.7,
	},
	matchName: {
		...type.rowTitle,
		color: colors.accent,
	},
	matchMeta: {
		...type.caption,
		color: colors.textSecondary,
	},
});

export default LeadMatchList;
